<template>
  <button class="menu-btn-ui" type="button">
    <span class="menu-btn-ui__bar"></span>
    <span class="menu-btn-ui__bar"></span>
    <span class="menu-btn-ui__bar"></span>
  </button>
</template>
